"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseColorPalette = void 0;
var _styles = require("@mui/material/styles");
var _colorOptions = require("../colorOptions");
var _xvantagePalette = require("./xvantage-palette");
/* eslint-disable max-lines */
/* eslint-disable sort-keys */

function _getContrastText(backgroundColor, foregroundColor, ratio) {
  return (0, _styles.getContrastRatio)(backgroundColor, _colorOptions.imColors.white) > ratio ? _colorOptions.imColors.white : foregroundColor;
}
var baseColorPalette = exports.baseColorPalette = {
  common: {
    black: _colorOptions.imColors.black,
    white: _colorOptions.imColors.white
  },
  color: _xvantagePalette.xvantageColorPalette,
  gray: {
    '25': _colorOptions.imColors.gray25,
    '50': _colorOptions.imColors.gray50,
    '100': _colorOptions.imColors.gray100,
    '200': _colorOptions.imColors.gray200,
    '300': _colorOptions.imColors.gray300,
    '400': _colorOptions.imColors.gray400,
    '500': _colorOptions.imColors.gray500,
    '600': _colorOptions.imColors.gray600,
    '700': _colorOptions.imColors.gray700,
    '800': _colorOptions.imColors.gray800,
    '900': _colorOptions.imColors.gray900,
    '950': _colorOptions.imColors.gray950,
    light: _colorOptions.imColors.gray300,
    main: _colorOptions.imColors.gray500,
    dark: _colorOptions.imColors.gray700,
    contrastText: _getContrastText(_colorOptions.imColors.gray500, _colorOptions.imColors.grayModern500, 1.25),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayModern500, 1.25);
    }
  },
  primary: {
    '25': _colorOptions.imColors.primary25,
    '50': _colorOptions.imColors.primary50,
    '100': _colorOptions.imColors.primary100,
    '200': _colorOptions.imColors.primary200,
    '300': _colorOptions.imColors.primary300,
    '400': _colorOptions.imColors.primary400,
    '500': _colorOptions.imColors.primary500,
    '600': _colorOptions.imColors.primary600,
    '700': _colorOptions.imColors.primary700,
    '800': _colorOptions.imColors.primary800,
    '900': _colorOptions.imColors.primary900,
    '950': _colorOptions.imColors.primary950,
    light: _colorOptions.imColors.primary300,
    main: _colorOptions.imColors.primary500,
    dark: _colorOptions.imColors.primary700,
    contrastText: _getContrastText(_colorOptions.imColors.primary500, _colorOptions.imColors.primary700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.primary700, 1.5);
    }
  },
  error: {
    '25': _colorOptions.imColors.error25,
    '50': _colorOptions.imColors.error50,
    '100': _colorOptions.imColors.error100,
    '200': _colorOptions.imColors.error200,
    '300': _colorOptions.imColors.error300,
    '400': _colorOptions.imColors.error400,
    '500': _colorOptions.imColors.error500,
    '600': _colorOptions.imColors.error600,
    '700': _colorOptions.imColors.error700,
    '800': _colorOptions.imColors.error800,
    '900': _colorOptions.imColors.error900,
    '950': _colorOptions.imColors.error950,
    light: _colorOptions.imColors.error300,
    main: _colorOptions.imColors.error500,
    dark: _colorOptions.imColors.error700,
    contrastText: _getContrastText(_colorOptions.imColors.error500, _colorOptions.imColors.error700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.error700, 1.5);
    }
  },
  warning: {
    '25': _colorOptions.imColors.warning25,
    '50': _colorOptions.imColors.warning50,
    '100': _colorOptions.imColors.warning100,
    '200': _colorOptions.imColors.warning200,
    '300': _colorOptions.imColors.warning300,
    '400': _colorOptions.imColors.warning400,
    '500': _colorOptions.imColors.warning500,
    '600': _colorOptions.imColors.warning600,
    '700': _colorOptions.imColors.warning700,
    '800': _colorOptions.imColors.warning800,
    '900': _colorOptions.imColors.warning900,
    '950': _colorOptions.imColors.warning950,
    light: _colorOptions.imColors.warning300,
    main: _colorOptions.imColors.warning500,
    dark: _colorOptions.imColors.warning700,
    contrastText: _getContrastText(_colorOptions.imColors.warning500, _colorOptions.imColors.warning700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.warning700, 1.5);
    }
  },
  success: {
    '25': _colorOptions.imColors.success25,
    '50': _colorOptions.imColors.success50,
    '100': _colorOptions.imColors.success100,
    '200': _colorOptions.imColors.success200,
    '300': _colorOptions.imColors.success300,
    '400': _colorOptions.imColors.success400,
    '500': _colorOptions.imColors.success500,
    '600': _colorOptions.imColors.success600,
    '700': _colorOptions.imColors.success700,
    '800': _colorOptions.imColors.success800,
    '900': _colorOptions.imColors.success900,
    '950': _colorOptions.imColors.success950,
    light: _colorOptions.imColors.success300,
    main: _colorOptions.imColors.success500,
    dark: _colorOptions.imColors.success700,
    contrastText: _getContrastText(_colorOptions.imColors.success500, _colorOptions.imColors.success700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.success700, 1.5);
    }
  },
  grayBlue: {
    '25': _colorOptions.imColors.grayBlue25,
    '50': _colorOptions.imColors.grayBlue50,
    '100': _colorOptions.imColors.grayBlue100,
    '200': _colorOptions.imColors.grayBlue200,
    '300': _colorOptions.imColors.grayBlue300,
    '400': _colorOptions.imColors.grayBlue400,
    '500': _colorOptions.imColors.grayBlue500,
    '600': _colorOptions.imColors.grayBlue600,
    '700': _colorOptions.imColors.grayBlue700,
    '800': _colorOptions.imColors.grayBlue800,
    '900': _colorOptions.imColors.grayBlue900,
    '950': _colorOptions.imColors.grayBlue950,
    light: _colorOptions.imColors.grayBlue300,
    main: _colorOptions.imColors.grayBlue500,
    dark: _colorOptions.imColors.grayBlue700,
    contrastText: _getContrastText(_colorOptions.imColors.grayBlue500, _colorOptions.imColors.grayBlue500, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayBlue500, 1.5);
    }
  },
  grayCool: {
    '25': _colorOptions.imColors.grayCool25,
    '50': _colorOptions.imColors.grayCool50,
    '100': _colorOptions.imColors.grayCool100,
    '200': _colorOptions.imColors.grayCool200,
    '300': _colorOptions.imColors.grayCool300,
    '400': _colorOptions.imColors.grayCool400,
    '500': _colorOptions.imColors.grayCool500,
    '600': _colorOptions.imColors.grayCool600,
    '700': _colorOptions.imColors.grayCool700,
    '800': _colorOptions.imColors.grayCool800,
    '900': _colorOptions.imColors.grayCool900,
    '950': _colorOptions.imColors.grayCool950,
    light: _colorOptions.imColors.grayCool300,
    main: _colorOptions.imColors.grayCool500,
    dark: _colorOptions.imColors.grayCool700,
    contrastText: _getContrastText(_colorOptions.imColors.grayCool500, _colorOptions.imColors.grayCool500, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayCool500, 1.5);
    }
  },
  grayModern: {
    '25': _colorOptions.imColors.grayModern25,
    '50': _colorOptions.imColors.grayModern50,
    '100': _colorOptions.imColors.grayModern100,
    '200': _colorOptions.imColors.grayModern200,
    '300': _colorOptions.imColors.grayModern300,
    '400': _colorOptions.imColors.grayModern400,
    '500': _colorOptions.imColors.grayModern500,
    '600': _colorOptions.imColors.grayModern600,
    '700': _colorOptions.imColors.grayModern700,
    '800': _colorOptions.imColors.grayModern800,
    '900': _colorOptions.imColors.grayModern900,
    '950': _colorOptions.imColors.grayModern950,
    light: _colorOptions.imColors.grayModern300,
    main: _colorOptions.imColors.grayModern500,
    dark: _colorOptions.imColors.grayModern700,
    contrastText: _getContrastText(_colorOptions.imColors.grayModern500, _colorOptions.imColors.grayModern500, 1.25),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayModern500, 1.25);
    }
  },
  grayNeutral: {
    '25': _colorOptions.imColors.grayNeutral25,
    '50': _colorOptions.imColors.grayNeutral50,
    '100': _colorOptions.imColors.grayNeutral100,
    '200': _colorOptions.imColors.grayNeutral200,
    '300': _colorOptions.imColors.grayNeutral300,
    '400': _colorOptions.imColors.grayNeutral400,
    '500': _colorOptions.imColors.grayNeutral500,
    '600': _colorOptions.imColors.grayNeutral600,
    '700': _colorOptions.imColors.grayNeutral700,
    '800': _colorOptions.imColors.grayNeutral800,
    '900': _colorOptions.imColors.grayNeutral900,
    '950': _colorOptions.imColors.grayNeutral950,
    light: _colorOptions.imColors.grayNeutral300,
    main: _colorOptions.imColors.grayNeutral500,
    dark: _colorOptions.imColors.grayNeutral700,
    contrastText: _getContrastText(_colorOptions.imColors.grayNeutral500, _colorOptions.imColors.grayNeutral500, 1.25),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayNeutral500, 1.25);
    }
  },
  grayIron: {
    '25': _colorOptions.imColors.grayIron25,
    '50': _colorOptions.imColors.grayIron50,
    '100': _colorOptions.imColors.grayIron100,
    '200': _colorOptions.imColors.grayIron200,
    '300': _colorOptions.imColors.grayIron300,
    '400': _colorOptions.imColors.grayIron400,
    '500': _colorOptions.imColors.grayIron500,
    '600': _colorOptions.imColors.grayIron600,
    '700': _colorOptions.imColors.grayIron700,
    '800': _colorOptions.imColors.grayIron800,
    '900': _colorOptions.imColors.grayIron900,
    '950': _colorOptions.imColors.grayIron950,
    light: _colorOptions.imColors.grayIron300,
    main: _colorOptions.imColors.grayIron500,
    dark: _colorOptions.imColors.grayIron700,
    contrastText: _getContrastText(_colorOptions.imColors.grayIron500, _colorOptions.imColors.grayIron500, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayIron500, 1.5);
    }
  },
  grayTrue: {
    '25': _colorOptions.imColors.grayTrue25,
    '50': _colorOptions.imColors.grayTrue50,
    '100': _colorOptions.imColors.grayTrue100,
    '200': _colorOptions.imColors.grayTrue200,
    '300': _colorOptions.imColors.grayTrue300,
    '400': _colorOptions.imColors.grayTrue400,
    '500': _colorOptions.imColors.grayTrue500,
    '600': _colorOptions.imColors.grayTrue600,
    '700': _colorOptions.imColors.grayTrue700,
    '800': _colorOptions.imColors.grayTrue800,
    '900': _colorOptions.imColors.grayTrue900,
    '950': _colorOptions.imColors.grayTrue950,
    light: _colorOptions.imColors.grayTrue300,
    main: _colorOptions.imColors.grayTrue500,
    dark: _colorOptions.imColors.grayTrue700,
    contrastText: _getContrastText(_colorOptions.imColors.grayTrue500, _colorOptions.imColors.grayTrue500, 1.35),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayTrue500, 1.35);
    }
  },
  grayWarm: {
    '25': _colorOptions.imColors.grayWarm25,
    '50': _colorOptions.imColors.grayWarm50,
    '100': _colorOptions.imColors.grayWarm100,
    '200': _colorOptions.imColors.grayWarm200,
    '300': _colorOptions.imColors.grayWarm300,
    '400': _colorOptions.imColors.grayWarm400,
    '500': _colorOptions.imColors.grayWarm500,
    '600': _colorOptions.imColors.grayWarm600,
    '700': _colorOptions.imColors.grayWarm700,
    '800': _colorOptions.imColors.grayWarm800,
    '900': _colorOptions.imColors.grayWarm900,
    '950': _colorOptions.imColors.grayWarm950,
    light: _colorOptions.imColors.grayWarm300,
    main: _colorOptions.imColors.grayWarm500,
    dark: _colorOptions.imColors.grayWarm700,
    contrastText: _getContrastText(_colorOptions.imColors.grayWarm500, _colorOptions.imColors.grayWarm500, 1.35),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.grayWarm500, 1.35);
    }
  },
  moss: {
    '25': _colorOptions.imColors.moss25,
    '50': _colorOptions.imColors.moss50,
    '100': _colorOptions.imColors.moss100,
    '200': _colorOptions.imColors.moss200,
    '300': _colorOptions.imColors.moss300,
    '400': _colorOptions.imColors.moss400,
    '500': _colorOptions.imColors.moss500,
    '600': _colorOptions.imColors.moss600,
    '700': _colorOptions.imColors.moss700,
    '800': _colorOptions.imColors.moss800,
    '900': _colorOptions.imColors.moss900,
    '950': _colorOptions.imColors.moss950,
    light: _colorOptions.imColors.moss300,
    main: _colorOptions.imColors.moss500,
    dark: _colorOptions.imColors.moss700,
    contrastText: _getContrastText(_colorOptions.imColors.moss500, _colorOptions.imColors.moss700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.moss700, 1.5);
    }
  },
  greenLight: {
    '25': _colorOptions.imColors.greenLight25,
    '50': _colorOptions.imColors.greenLight50,
    '100': _colorOptions.imColors.greenLight100,
    '200': _colorOptions.imColors.greenLight200,
    '300': _colorOptions.imColors.greenLight300,
    '400': _colorOptions.imColors.greenLight400,
    '500': _colorOptions.imColors.greenLight500,
    '600': _colorOptions.imColors.greenLight600,
    '700': _colorOptions.imColors.greenLight700,
    '800': _colorOptions.imColors.greenLight800,
    '900': _colorOptions.imColors.greenLight900,
    '950': _colorOptions.imColors.greenLight950,
    light: _colorOptions.imColors.greenLight300,
    main: _colorOptions.imColors.greenLight500,
    dark: _colorOptions.imColors.greenLight700,
    contrastText: _getContrastText(_colorOptions.imColors.greenLight700, _colorOptions.imColors.greenLight700, 1.25),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.greenLight700, 1.25);
    }
  },
  green: {
    '25': _colorOptions.imColors.green25,
    '50': _colorOptions.imColors.green50,
    '100': _colorOptions.imColors.green100,
    '200': _colorOptions.imColors.green200,
    '300': _colorOptions.imColors.green300,
    '400': _colorOptions.imColors.green400,
    '500': _colorOptions.imColors.green500,
    '600': _colorOptions.imColors.green600,
    '700': _colorOptions.imColors.green700,
    '800': _colorOptions.imColors.green800,
    '900': _colorOptions.imColors.green900,
    '950': _colorOptions.imColors.green950,
    light: _colorOptions.imColors.green300,
    main: _colorOptions.imColors.green500,
    dark: _colorOptions.imColors.green700,
    contrastText: _getContrastText(_colorOptions.imColors.green500, _colorOptions.imColors.green700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.green700, 1.5);
    }
  },
  teal: {
    '25': _colorOptions.imColors.teal25,
    '50': _colorOptions.imColors.teal50,
    '100': _colorOptions.imColors.teal100,
    '200': _colorOptions.imColors.teal200,
    '300': _colorOptions.imColors.teal300,
    '400': _colorOptions.imColors.teal400,
    '500': _colorOptions.imColors.teal500,
    '600': _colorOptions.imColors.teal600,
    '700': _colorOptions.imColors.teal700,
    '800': _colorOptions.imColors.teal800,
    '900': _colorOptions.imColors.teal900,
    '950': _colorOptions.imColors.teal950,
    light: _colorOptions.imColors.teal300,
    main: _colorOptions.imColors.teal500,
    dark: _colorOptions.imColors.teal700,
    contrastText: _getContrastText(_colorOptions.imColors.teal500, _colorOptions.imColors.teal700, 1.35),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.teal700, 1.35);
    }
  },
  cyan: {
    '25': _colorOptions.imColors.cyan25,
    '50': _colorOptions.imColors.cyan50,
    '100': _colorOptions.imColors.cyan100,
    '200': _colorOptions.imColors.cyan200,
    '300': _colorOptions.imColors.cyan300,
    '400': _colorOptions.imColors.cyan400,
    '500': _colorOptions.imColors.cyan500,
    '600': _colorOptions.imColors.cyan600,
    '700': _colorOptions.imColors.cyan700,
    '800': _colorOptions.imColors.cyan800,
    '900': _colorOptions.imColors.cyan900,
    '950': _colorOptions.imColors.cyan950,
    light: _colorOptions.imColors.cyan300,
    main: _colorOptions.imColors.cyan500,
    dark: _colorOptions.imColors.cyan700,
    contrastText: _getContrastText(_colorOptions.imColors.cyan500, _colorOptions.imColors.cyan700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.cyan700, 1.5);
    }
  },
  blueLight: {
    '25': _colorOptions.imColors.blueLight25,
    '50': _colorOptions.imColors.blueLight50,
    '100': _colorOptions.imColors.blueLight100,
    '200': _colorOptions.imColors.blueLight200,
    '300': _colorOptions.imColors.blueLight300,
    '400': _colorOptions.imColors.blueLight400,
    '500': _colorOptions.imColors.blueLight500,
    '600': _colorOptions.imColors.blueLight600,
    '700': _colorOptions.imColors.blueLight700,
    '800': _colorOptions.imColors.blueLight800,
    '900': _colorOptions.imColors.blueLight900,
    '950': _colorOptions.imColors.blueLight950,
    light: _colorOptions.imColors.blueLight300,
    main: _colorOptions.imColors.blueLight500,
    dark: _colorOptions.imColors.blueLight700,
    contrastText: _getContrastText(_colorOptions.imColors.blueLight500, _colorOptions.imColors.blueLight700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.blueLight700, 1.5);
    }
  },
  blue: {
    '25': _colorOptions.imColors.blue25,
    '50': _colorOptions.imColors.blue50,
    '100': _colorOptions.imColors.blue100,
    '200': _colorOptions.imColors.blue200,
    '300': _colorOptions.imColors.blue300,
    '400': _colorOptions.imColors.blue400,
    '500': _colorOptions.imColors.blue500,
    '600': _colorOptions.imColors.blue600,
    '700': _colorOptions.imColors.blue700,
    '800': _colorOptions.imColors.blue800,
    '900': _colorOptions.imColors.blue900,
    '950': _colorOptions.imColors.blue950,
    light: _colorOptions.imColors.blue300,
    main: _colorOptions.imColors.blue500,
    dark: _colorOptions.imColors.blue700,
    contrastText: _getContrastText(_colorOptions.imColors.blue500, _colorOptions.imColors.blue700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.blue700, 1.5);
    }
  },
  blueDark: {
    '25': _colorOptions.imColors.blueDark25,
    '50': _colorOptions.imColors.blueDark50,
    '100': _colorOptions.imColors.blueDark100,
    '200': _colorOptions.imColors.blueDark200,
    '300': _colorOptions.imColors.blueDark300,
    '400': _colorOptions.imColors.blueDark400,
    '500': _colorOptions.imColors.blueDark500,
    '600': _colorOptions.imColors.blueDark600,
    '700': _colorOptions.imColors.blueDark700,
    '800': _colorOptions.imColors.blueDark800,
    '900': _colorOptions.imColors.blueDark900,
    '950': _colorOptions.imColors.blueDark950,
    light: _colorOptions.imColors.blueDark300,
    main: _colorOptions.imColors.blueDark500,
    dark: _colorOptions.imColors.blueDark700,
    contrastText: _getContrastText(_colorOptions.imColors.blueDark500, _colorOptions.imColors.blueDark700, 1.75),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.blueDark700, 1.75);
    }
  },
  indigo: {
    '25': _colorOptions.imColors.indigo25,
    '50': _colorOptions.imColors.indigo50,
    '100': _colorOptions.imColors.indigo100,
    '200': _colorOptions.imColors.indigo200,
    '300': _colorOptions.imColors.indigo300,
    '400': _colorOptions.imColors.indigo400,
    '500': _colorOptions.imColors.indigo500,
    '600': _colorOptions.imColors.indigo600,
    '700': _colorOptions.imColors.indigo700,
    '800': _colorOptions.imColors.indigo800,
    '900': _colorOptions.imColors.indigo900,
    '950': _colorOptions.imColors.indigo950,
    light: _colorOptions.imColors.indigo300,
    main: _colorOptions.imColors.indigo500,
    dark: _colorOptions.imColors.indigo700,
    contrastText: _getContrastText(_colorOptions.imColors.indigo500, _colorOptions.imColors.indigo700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.indigo700, 1.5);
    }
  },
  violet: {
    '25': _colorOptions.imColors.violet25,
    '50': _colorOptions.imColors.violet50,
    '100': _colorOptions.imColors.violet100,
    '200': _colorOptions.imColors.violet200,
    '300': _colorOptions.imColors.violet300,
    '400': _colorOptions.imColors.violet400,
    '500': _colorOptions.imColors.violet500,
    '600': _colorOptions.imColors.violet600,
    '700': _colorOptions.imColors.violet700,
    '800': _colorOptions.imColors.violet800,
    '900': _colorOptions.imColors.violet900,
    '950': _colorOptions.imColors.violet950,
    light: _colorOptions.imColors.violet300,
    main: _colorOptions.imColors.violet500,
    dark: _colorOptions.imColors.violet700,
    contrastText: _getContrastText(_colorOptions.imColors.violet500, _colorOptions.imColors.violet700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.violet700, 1.5);
    }
  },
  purple: {
    '25': _colorOptions.imColors.purple25,
    '50': _colorOptions.imColors.purple50,
    '100': _colorOptions.imColors.purple100,
    '200': _colorOptions.imColors.purple200,
    '300': _colorOptions.imColors.purple300,
    '400': _colorOptions.imColors.purple400,
    '500': _colorOptions.imColors.purple500,
    '600': _colorOptions.imColors.purple600,
    '700': _colorOptions.imColors.purple700,
    '800': _colorOptions.imColors.purple800,
    '900': _colorOptions.imColors.purple900,
    '950': _colorOptions.imColors.purple950,
    light: _colorOptions.imColors.purple300,
    main: _colorOptions.imColors.purple500,
    dark: _colorOptions.imColors.purple700,
    contrastText: _getContrastText(_colorOptions.imColors.purple500, _colorOptions.imColors.purple700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.purple700, 1.5);
    }
  },
  fuchsia: {
    '25': _colorOptions.imColors.fuchsia25,
    '50': _colorOptions.imColors.fuchsia50,
    '100': _colorOptions.imColors.fuchsia100,
    '200': _colorOptions.imColors.fuchsia200,
    '300': _colorOptions.imColors.fuchsia300,
    '400': _colorOptions.imColors.fuchsia400,
    '500': _colorOptions.imColors.fuchsia500,
    '600': _colorOptions.imColors.fuchsia600,
    '700': _colorOptions.imColors.fuchsia700,
    '800': _colorOptions.imColors.fuchsia800,
    '900': _colorOptions.imColors.fuchsia900,
    '950': _colorOptions.imColors.fuchsia950,
    light: _colorOptions.imColors.fuchsia300,
    main: _colorOptions.imColors.fuchsia500,
    dark: _colorOptions.imColors.fuchsia700,
    contrastText: _getContrastText(_colorOptions.imColors.fuchsia500, _colorOptions.imColors.fuchsia700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.fuchsia700, 1.5);
    }
  },
  pink: {
    '25': _colorOptions.imColors.pink25,
    '50': _colorOptions.imColors.pink50,
    '100': _colorOptions.imColors.pink100,
    '200': _colorOptions.imColors.pink200,
    '300': _colorOptions.imColors.pink300,
    '400': _colorOptions.imColors.pink400,
    '500': _colorOptions.imColors.pink500,
    '600': _colorOptions.imColors.pink600,
    '700': _colorOptions.imColors.pink700,
    '800': _colorOptions.imColors.pink800,
    '900': _colorOptions.imColors.pink900,
    '950': _colorOptions.imColors.pink950,
    light: _colorOptions.imColors.pink300,
    main: _colorOptions.imColors.pink500,
    dark: _colorOptions.imColors.pink700,
    contrastText: _getContrastText(_colorOptions.imColors.pink500, _colorOptions.imColors.pink700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.pink700, 1.5);
    }
  },
  rose: {
    '25': _colorOptions.imColors.rose25,
    '50': _colorOptions.imColors.rose50,
    '100': _colorOptions.imColors.rose100,
    '200': _colorOptions.imColors.rose200,
    '300': _colorOptions.imColors.rose300,
    '400': _colorOptions.imColors.rose400,
    '500': _colorOptions.imColors.rose500,
    '600': _colorOptions.imColors.rose600,
    '700': _colorOptions.imColors.rose700,
    '800': _colorOptions.imColors.rose800,
    '900': _colorOptions.imColors.rose900,
    '950': _colorOptions.imColors.rose950,
    light: _colorOptions.imColors.rose300,
    main: _colorOptions.imColors.rose500,
    dark: _colorOptions.imColors.rose700,
    getContrastText: function getContrastText(color) {
      return (0, _styles.getContrastRatio)(color, _colorOptions.imColors.white) > 1.5 ? _colorOptions.imColors.white : _colorOptions.imColors.pink700;
    }
  },
  orangeDark: {
    '25': _colorOptions.imColors.orangeDark25,
    '50': _colorOptions.imColors.orangeDark50,
    '100': _colorOptions.imColors.orangeDark100,
    '200': _colorOptions.imColors.orangeDark200,
    '300': _colorOptions.imColors.orangeDark300,
    '400': _colorOptions.imColors.orangeDark400,
    '500': _colorOptions.imColors.orangeDark500,
    '600': _colorOptions.imColors.orangeDark600,
    '700': _colorOptions.imColors.orangeDark700,
    '800': _colorOptions.imColors.orangeDark800,
    '900': _colorOptions.imColors.orangeDark900,
    '950': _colorOptions.imColors.orangeDark950,
    light: _colorOptions.imColors.orangeDark300,
    main: _colorOptions.imColors.orangeDark500,
    dark: _colorOptions.imColors.orangeDark700,
    contrastText: _getContrastText(_colorOptions.imColors.orangeDark500, _colorOptions.imColors.orange700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.orange700, 1.5);
    }
  },
  orange: {
    '25': _colorOptions.imColors.orange25,
    '50': _colorOptions.imColors.orange50,
    '100': _colorOptions.imColors.orange100,
    '200': _colorOptions.imColors.orange200,
    '300': _colorOptions.imColors.orange300,
    '400': _colorOptions.imColors.orange400,
    '500': _colorOptions.imColors.orange500,
    '600': _colorOptions.imColors.orange600,
    '700': _colorOptions.imColors.orange700,
    '800': _colorOptions.imColors.orange800,
    '900': _colorOptions.imColors.orange900,
    '950': _colorOptions.imColors.orange950,
    light: _colorOptions.imColors.orange300,
    main: _colorOptions.imColors.orange500,
    dark: _colorOptions.imColors.orange700,
    contrastText: _getContrastText(_colorOptions.imColors.orange500, _colorOptions.imColors.orange700, 1.5),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.orange700, 1.5);
    }
  },
  yellow: {
    '25': _colorOptions.imColors.yellow25,
    '50': _colorOptions.imColors.yellow50,
    '100': _colorOptions.imColors.yellow100,
    '200': _colorOptions.imColors.yellow200,
    '300': _colorOptions.imColors.yellow300,
    '400': _colorOptions.imColors.yellow400,
    '500': _colorOptions.imColors.yellow500,
    '600': _colorOptions.imColors.yellow600,
    '700': _colorOptions.imColors.yellow700,
    '800': _colorOptions.imColors.yellow800,
    '900': _colorOptions.imColors.yellow900,
    '950': _colorOptions.imColors.yellow950,
    light: _colorOptions.imColors.yellow300,
    main: _colorOptions.imColors.yellow500,
    dark: _colorOptions.imColors.yellow700,
    contrastText: _getContrastText(_colorOptions.imColors.yellow500, _colorOptions.imColors.yellow700, 1.25),
    getContrastText: function getContrastText(color) {
      return _getContrastText(color, _colorOptions.imColors.yellow700, 1.25);
    }
  }
};